// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-chat-conversation-list-screen .conversation-new-button {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chat/fi-chat-conversation-list/fi-chat-conversation-list-screen/fi-chat-conversation-list-screen.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR","sourcesContent":[".fi-chat-conversation-list-screen {\r\n    .conversation-new-button {\r\n        font-size: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
